import { SortSymbols } from '@webitel/ui-sdk/src/scripts/sortQueryAdapters';

export default [
  {
    value: 'name',
    locale: 'objects.name',
    field: 'name',
    sort: SortSymbols.NONE,
  },
  {
    value: 'strategy',
    locale: 'objects.ccenter.teams.strategy',
    field: 'strategy',
    sort: SortSymbols.NONE,
  },
];
